import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  // generateSaSToken, 
  sendWhatsappMessage,
  updateTicket,
  getCompanyById
} from "../../pages/actions/actions";
import { currentDateTime, removeFieldFn } from "../../utils/helper";
import { ShowAlert } from "../../utils/showAlert";
import { UseGetStoreData } from "../getStoreData/UseGetStoreData";
import { useEmergencyContact } from "../useEmergencyContact/UseEmergencyContact";
import { ticketUpdateStatusSuccess } from "../../redux/ticketUpdateSlice/ticketUpdateSlice";
import { ticketDataSuccess } from "../../redux/ticketSlice/ticketSlice";

export const useInsuranceCard = ({ data }: any) => {
  const dispatch = useDispatch();
  const { getTicketUpdateData, getTicketData } = UseGetStoreData()
  const { validContacts } = useEmergencyContact()
  let excludedField = ["_id", "expiry"];
  const filteredData = removeFieldFn(data, excludedField)
  // console.log(filteredData,"filteredData")

  const [companyTPADocument, setCompanyTPADocument] = useState('');
  const [docUrl,setDocUrl]=useState("")
  const handleShareInsuranceDet = async () => {
    // Update ticket with patient data if missing
    if (!getTicketData?.patient && getTicketUpdateData?.patient) {
      try {
        const res = await updateTicket(getTicketData._id, { patient: getTicketUpdateData.patient });
        if (res) {
          dispatch(ticketDataSuccess(res.data));
        }
      } catch (error) {
        console.error('Error updating patient:', error);
      }
    }

    const getPatientName = getTicketData?.patient?.fullName || getTicketUpdateData?.patient?.fullName;
    if (!data || !getPatientName) {
      ShowAlert("warning", "Insurance Details Not Found or Select Patient")
    } else if (!validContacts.length) {
      ShowAlert("warning", "Patient or Emergency COntact Not found")
    }
    else {
      let excludedField = ["_id", "expiry", "docUrl"];
      const filteredData = removeFieldFn(data, excludedField)
      const payloadArray = filteredData?.map((insurance: any) => {
        if (companyTPADocument && companyTPADocument !== '' && insurance?.typeOfPolicy === 'Corporate') {
          return {
            template: "NOTIFY_SUBSCRIBER_ABOUT_INSURANCE_TPA",
            data: {
              benName: getPatientName,
              policyId: insurance?.policyId || "Not Available",
              nameOfInsurer: insurance?.nameOfInsurer || "Not Available",
              tpaName: insurance?.tpaName || "Not Available",
              typeOfPolicy: insurance?.typeOfPolicy || "Not Available",
              to: [...validContacts]
            },
            btnValues: {
              tpaDocument: companyTPADocument
            }
          }
        }
        return {
          template: "SINGLE_INSURANCE_DETAILS",
          data: {
            benName: getPatientName,
            policyId: insurance?.policyId || "Not Available",
            nameOfInsurer: insurance?.nameOfInsurer || "Not Available",
            tpaName: insurance?.tpaName || "Not Available",
            typeOfPolicy: insurance?.typeOfPolicy || "Not Available",
            to: [...validContacts]
          }
        }
      })

      const insuranceSharedPayload = {
        notes: [...getTicketData?.notes, {
          date: currentDateTime(),
          message: "Insurance details shared to patient"
        }]
      };

      try {
        await Promise.all(payloadArray.map((p: any) => sendWhatsappMessage(p)));
        const res = await updateTicket(getTicketData._id, insuranceSharedPayload);
        if (res) {
          dispatch(ticketUpdateStatusSuccess(res.data));
          dispatch(ticketDataSuccess(res.data));
          ShowAlert("success", "Insurance details send to patient")
        } else {
          ShowAlert("warning", "some issue while updating ticket")
        }
      } catch (e: any) {
        return ShowAlert("warning", e.response?.data?.message || "some issue while sending Whatsapp Message")
      }
    }

  };

  useEffect(() => {
    const companyId = getTicketData?.companyId || getTicketUpdateData?.companyId;
    if (companyId) {
      const fetchData = async () => {
        try {
          const res = await getCompanyById(companyId);
          const tpaDocumentUrl = res?.data?.data?.[0]?.tpaDocument;
          setDocUrl(tpaDocumentUrl)
          if (tpaDocumentUrl) {
            const tpaDocument = tpaDocumentUrl?.split('tpadocument/')?.[1];
            setCompanyTPADocument(tpaDocument);
          }
        } catch (error) {
          console.error(error);
          throw error;
        }
      };
      fetchData();
    }
  }, [getTicketData, getTicketUpdateData])
  return {
    handleShareInsuranceDet,
    filteredData,
    docUrl
  }
}